import React, { useEffect, useState } from "react";
import { getAllcompanies } from "../../../../redux/apiCalls/companiesCall/companiesCall";

const BranchSelector = ({ value, onChange, userToken, dispatch }) => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!userToken) return;

    const fetchBranches = async () => {
      setLoading(true);
      try {
        const result = await getAllcompanies(
          dispatch,
          userToken,
          "branch_offices"
        );
        if (Array.isArray(result)) {
          setBranches(result);
        }
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBranches();
  }, [userToken, dispatch]);

  // Transformar branches a opciones
  useEffect(() => {
    const opts = branches.map((branch) => ({
      id: branch.id,
      name: branch.name || branch.office_name || branch.nombres || "",
      code: branch.code || "",
      ...branch,
    }));
    setOptions(opts);
  }, [branches]);

  const handleChange = (e) => {
    const selectedId = e.target.value;
    if (!selectedId) {
      onChange(null);
      return;
    }

    if (selectedId === "all") {
      onChange({ id: "all", name: "Todas mis sucursales", code: "" });
      return;
    }

    const selected = options.find((opt) => String(opt.id) === selectedId);
    if (selected) {
      onChange({
        id: selected.id,
        name: selected.name,
        code: selected.code,
      });
    }
  };

  return (
    <div className="selector-wrapper">
      <select
        className="field-select"
        value={value?.id ?? ""}
        onChange={handleChange}
        disabled={loading}
      >
        <option value="">{loading ? "Cargando sucursales..." : "Seleccionar sucursal..."}</option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.name || `Sucursal ${opt.id}`}
          </option>
        ))}
      </select>
      {value && <div className="selected-value">{value.name}</div>}
    </div>
  );
};

export default BranchSelector;
